import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useAppDispatch, useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';
import { setNavigationPlace } from 'src/modules/shared/slices/navigationBar/navigationBarSlice';
import { setClickedOnNavgationBarIndex } from 'src/store/table-of-contents/tableOfContentsSlice';

const TOCSearchNavigationBar: React.FC = () => {
  const dispatch = useAppDispatch();
  let history = useHistory();
  const clickedOnNavBar = useAppSelector((state) => state.tableOfContents.clickedOnNavBar);

  useEffect(() => {
    dispatch(setNavigationPlace('table-of-contents'));
    dispatch(setClickedOnNavgationBarIndex(''));
  }, [dispatch]);

  useEffect(() => {
    if (!clickedOnNavBar) return;
    if (clickedOnNavBar) {
      history.goBack();
    }
  }, [clickedOnNavBar, history]);

  useEffect(
    () => () => {
      dispatch(setNavigationPlace(null));
    },
    [dispatch]
  );

  return null;
};

export default TOCSearchNavigationBar;
